<template>
  <zb-radio-group
    :action="plansAction"
    :model-value="value"
    v-bind="$attrs"
  >
    <slot
      v-for="slot in Object.keys($slots)"
      :key="slot"
      :name="slot"
      v-bind="$slots[slot].scope || {}"
    />
  </zb-radio-group>
</template>
<script>
import ZbRadioGroup from '@/components/zoom-ui-plus/radio/radio-group.vue';

export default {
  name: 'CategoryRadioGroup',
  props: {
    plans: Array,
    action: Function,
    groupCategoryKey: {
      type: String,
      default: 'capacity',
    },
    value: String,
  },

  methods: {
    plansAction(oldVal, val) {
      const oldPlan = this.plans.find(item => item?.[this.groupCategoryKey] === oldVal);
      const newPlan = this.plans.find(item => item?.[this.groupCategoryKey] === val);
      return this.action(oldPlan, newPlan);
    }
  },
  components: {
    ZbRadioGroup,
  },
}
</script>
